import { User } from '@monsido/modules/models/api/user';

export class BackendAdminUserForm extends User {
    public password?: string;
    public password_confirmation?: string;
    public reseller_admin?: boolean;
    public send_welcome_email?: boolean;
}
